import React from "react";
import { useSelector } from "react-redux";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import { IconButton } from "@material-ui/core";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {Skeleton} from '@material-ui/lab';
const useStyles = makeStyles((theme) => ({
  header: {
    color: theme?.palette?.ePrimary?.base,
    fontWeight: "bold",
    marginBottom: "0.5rem",
    marginTop: "0.5rem",
  },
  edit: {
    color: theme?.palette?.ePrimary?.base,
    fontSize: "1rem",
    marginLeft: "0.75rem",
  },
  pad: {
    padding: "0rem",
    "&&:hover": {
      backgroundColor: theme?.palette?.eWhite?.base,
    },
  },
  bodyText: {
    color: theme?.palette?.eDark?.hover,
    fontWeight: "bold",
  },
  bodyText2: {
    color: theme?.palette?.ePrimary?.base,
    fontWeight: "bold",
    marginLeft: "0.5rem",
  },
  bodyText3: {
    color: theme?.palette?.eDark?.hover,
    fontWeight: "bold",
  },
  paddingtop: {
    paddingTop: "1%",
  },
  paddingtop2: {
    paddingTop: "1%",
  },
}));
export default function ESummaryDetails(props) {
  const {
    allAttachedFiles,
    name,
    fatherName,
    husbandWifeRadio,
    husbandName,
    motherName,
    email,
    mobile,
    idType,
    idValue,
    dropDownData,
    individualVerifiedMobile,
    tarrifType,
    Load,
    meterType,
    idTypeOthers,
    isIndividualMobileVerified,
    existingCustomer,
    existingCustomerID,
    connectionType,
    tinValue,
    noOfConnections,
    districtPremise,
    address1Premise,
    address2Premise,
    postOfficePremise,
    divisionPremise,
    postCodePremise,
    thanaPremise,
    districtMailing,
    address1Mailing,
    address2Mailing,
    postOfficeMailing,
    divisionMailing,
    postCodeMailing,
    thanaMailing,
    connectionOnExistingPremise,
    premiseType,
    premiseCategory,
    sndValue,
    termsAgreedTime,
    setActiveStep,
    masterDataName,
    userEnteredMobileNumber,
    masterDataFatherName,
    masterDataMotherName,
    masterDataHusbandName,
    masterDataEmail,
    masterDataIdValue,
    masterDataTinValue,
    masterDataAddress1Mailing,
    masterDataAddress2Mailing,
    masterDataPostOfficeMailing,
    masterDataThanaMailing,
    masterDataDistrictMailing,
    masterDataDivisionMailing,
    masterDataPostCodeMailing,
    masterDatahusbandWifeRadio
  } = props;
  const HUSBAND_RADIO_VALUE = "husband";
  let existinghusbnamecheck=masterDatahusbandWifeRadio == HUSBAND_RADIO_VALUE ? "E_SUMMARY_HUSBAND_NAME" : "E_SUMMARY_WIFE_NAME"
  let husbnamecheck=HUSBAND_RADIO_VALUE ? "E_SUMMARY_HUSBAND_NAME" : "E_SUMMARY_WIFE_NAME"
  let husbwiferadiobutton=existingCustomer=="yes" ? existinghusbnamecheck: husbnamecheck
  const summaryClass = useStyles();
  const [applicantDetailsKeys, setApplicantDetailsKeys] = useState([
    "E_NAME_LABEL",
    "E_MOBILE_LABEL",
    "E_SUMMARY_FATHER_NAME",
    "E_SUMMARY_MOTHER_NAME",
    husbwiferadiobutton,
    "E_EMAIL_LABEL",
    "E_SUMMARY_CONNECTION_TYPE",
    "E_SUMMARY_METER_TYPE",
    "E_SUMMARY_TARIIF_TYPE",
    "E_SUMMARY_LOAD",
    "E_SUMMARY_ID_TYPE",
    "E_SUMMARY_ID_VALUE",
    "E_TIN_NUMBER",
    "E_NO_OF_CONNECTIONS_VALUE"
  ]);
  const mobileCode = useSelector(
    (state) => state?.parametersWidgets?.ParameterLookup?.COUNTRY_DIALING_CODE
  );
  const [applicantDetailsValues, setApplicantDetailsValues] = useState([]);
  const [existingCustomerapplicantDetailsValues,setexistingCustomerapplicantDetailsValues]=useState({})
  useEffect(() => {
    setApplicantDetailsValues([
      name,
      mobileCode + mobile,
      fatherName,
      motherName,
      husbandName,
      email,
      connectionType,
      meterType,
      tarrifType,
      Load,
      idType,
      idValue,
      tinValue,
      noOfConnections
      
    ]);
  }, [
    name,
    mobileCode,
    mobile,
    fatherName,
    motherName,
    husbandName,
    email,
    connectionType,
    meterType,
    tarrifType,
    Load,
    idType,
    idValue,
    tinValue,
    noOfConnections
  ]);
  useEffect(() => {
    setexistingCustomerapplicantDetailsValues([
      masterDataName,
      mobileCode + userEnteredMobileNumber,
      masterDataFatherName,
      masterDataMotherName,
      masterDataHusbandName,
      masterDataEmail,
      connectionType,
      meterType,
      tarrifType,
      Load,
      idType,
      masterDataIdValue,
      masterDataTinValue,
      noOfConnections
      
    ]);
  }, [
    masterDataName,
    mobileCode,
    userEnteredMobileNumber,
    masterDataFatherName,
    masterDataMotherName,
    masterDataHusbandName,
    masterDataEmail,
    connectionType,
    meterType,
    tarrifType,
    Load,
    idType,
    masterDataIdValue,
    masterDataTinValue,
    noOfConnections
  ]);
  const { t: labels, ready: labelReady } = useTranslation("label-E_SUMMARY_REVIEW");
  const { t: label, ready: labelReadys } = useTranslation("label-E_APPLICANT_DETAILS");
  const applicationEditCall = () => {
    setActiveStep(0);
  };
  const premiseEditCall = () => {
    setActiveStep(1);
  };
  const documentEditCall = () => {
    setActiveStep(2);
  };

  return (
    <>
      <Grid container direction="rows">
        <Grid item sm={12} xs={12}>
        {
          labelReady ?
          <Typography variant="h6" className={summaryClass.header}>
            {labels("E_SUBITLE")}
          </Typography>
          : <Skeleton />
        }
        </Grid>
        <Grid item sm={12} xs={12}>
        {
          labelReady ?
          <Typography variant="subtitle1" className={summaryClass.header}>
            {labels("E_APPLICANT_DETAILS")}
            <IconButton className={summaryClass.pad}>
              <BorderColorIcon
                onClick={applicationEditCall}
                className={summaryClass.edit}
              />
            </IconButton>
          </Typography>
          : <Skeleton />
        }
        </Grid>
        {existingCustomer=="yes" ? 
        (<Grid container>
          {applicantDetailsKeys?.map((item, index) => (
            <Grid item sm={4} xs={9}>
            {
              labelReady ?
              <Typography variant="body2" className={summaryClass.bodyText}>
                {item==="E_TIN_NUMBER" ? label(item) : labels(item)}
                <span variant="body2" className={summaryClass.bodyText2}>
                  {existingCustomerapplicantDetailsValues[index]
                    ? existingCustomerapplicantDetailsValues[index]
                    : labels("E_SUMMARY_EMPTY_VALUE")}
                </span>
              </Typography>
              : <Skeleton />
            }
            </Grid>
          ))}
        </Grid>): 
        (<Grid container>
          {applicantDetailsKeys?.map((item, index) => (
            <Grid item sm={4} xs={9}>
            {
              labelReady ?
              <Typography variant="body2" className={summaryClass.bodyText}>
                {item==="E_TIN_NUMBER" ? label(item) : labels(item)}
                <span variant="body2" className={summaryClass.bodyText2}>
                  {applicantDetailsValues[index]
                    ? applicantDetailsValues[index]
                    : labels("E_SUMMARY_EMPTY_VALUE")}
                </span>
              </Typography>
              : <Skeleton />
            }
            </Grid>
          ))}
        </Grid>)}
        <Grid item sm={12} xs={12} className={summaryClass.paddingtop}>
        {
          labelReady ?
          <Typography variant="subtitle1" className={summaryClass.header}>
            {labels("E_PREMISE_DETAILS_TITLE")}
            <IconButton className={summaryClass.pad}>
              <BorderColorIcon
                onClick={premiseEditCall}
                className={summaryClass.edit}
              />
            </IconButton>
          </Typography>
          : <Skeleton />
        }
        </Grid>
        <Grid container>
          <Grid item sm={4} xs={9}>
          {
            labelReady ?
            <Typography variant="body2" className={summaryClass.bodyText}>
              {labels("E_SUMMARY_PREMISE_TYPE")}
              <span variant="body2" className={summaryClass.bodyText2}>
                {premiseType ? premiseType : labels("E_SUMMARY_EMPTY_VALUE")}
              </span>
            </Typography>
            : <Skeleton />
          }
          </Grid>
          <Grid item sm={4} xs={9}>
          {
            labelReady ?
            <Typography variant="body2" className={summaryClass.bodyText}>
              {labels("E_SUMMARY_PREMISE_CATEGORY")}
              <span variant="body2" className={summaryClass.bodyText2}>
                {premiseCategory ? premiseCategory : labels("E_SUMMARY_EMPTY_VALUE")}
              </span>
            </Typography>
            : <Skeleton />
          }
          </Grid>
          <Grid item sm={12} xs={12}>
          {
            labelReady ?
            <Typography variant="body2" className={summaryClass.bodyText3}>
              {labels("E_SUMMARY_CONNECTION_ADDERESS")}
              <span variant="body2" className={summaryClass.bodyText2}>
                {address1Premise} {address2Premise} {thanaPremise}{" "}
                {districtPremise} {sndValue}  {postOfficePremise}{" "}
                {divisionPremise}  {postCodePremise}                   
              </span>
            </Typography>
            : <Skeleton />
          }
          </Grid>
          {existingCustomer=="yes" ? (<Grid item sm={12} xs={13}>
          {
            labelReady ?
            <Typography variant="body2" className={summaryClass.bodyText3}>
              {labels("E_SUMMARY_COMMUNICATION_DETAILS")}
              <span variant="body2" className={summaryClass.bodyText2}>
                {masterDataAddress1Mailing} {masterDataAddress2Mailing} {masterDataThanaMailing}{" "}
                {masterDataDistrictMailing} {masterDataPostOfficeMailing} {masterDataDivisionMailing}{" "}
                {masterDataPostCodeMailing}
              </span>
            </Typography>
            : <Skeleton />
          }
          </Grid>):(
<Grid item sm={12} xs={13}>
{
  labelReady ?
  <Typography variant="body2" className={summaryClass.bodyText3}>
    {labels("E_SUMMARY_COMMUNICATION_DETAILS")}
    <span variant="body2" className={summaryClass.bodyText2}>
      {address1Mailing} {address2Mailing} {thanaMailing}{" "}
      {districtMailing} {postOfficeMailing} {divisionMailing}{" "}
      {postCodeMailing}
    </span>
  </Typography>
  : <Skeleton />
}
</Grid>
          )}
          
        </Grid>
        <Grid item sm={12} xs={12} className={summaryClass.paddingtop}>
        {
          labelReady ? 
          <Typography variant="subtitle1" className={summaryClass.header}>
            {labels("E_UPLOAD_DOCUMENTS")}
            <IconButton className={summaryClass.pad}>
              <BorderColorIcon
                onClick={documentEditCall}
                className={summaryClass.edit}
              />
            </IconButton>
          </Typography>
          : <Skeleton />
        }
        </Grid>
        <Grid container>
          <Grid item sm={12} xs={12}>
          {
            labelReady ? 
            <Typography variant="body2" className={summaryClass.bodyText3}>
              {labels("E_FILE_ATTACHED_LABEL")}
              <span variant="body2" className={summaryClass.bodyText2}>
                {allAttachedFiles?.length} {labels("E_FILES_LABEL")}
              </span>
            </Typography>
            : <Skeleton />
          }
            <Typography variant="body2" className={summaryClass.bodyText3}>
              <span variant="body2" className={summaryClass.bodyText2}>
                (
                {allAttachedFiles?.map((item, k) => {
                  return (
                    <>
                      {item.fileName}
                      {allAttachedFiles.length - 1 > k && ", "}
                    </>
                  );
                })}
                )
              </span>
            </Typography>
          </Grid>
          <Grid item sm={12} xs={13}>
          {
            labelReady ?
            <Typography variant="body2" className={summaryClass.bodyText3}>
              {labels("E_TERMS_AGREED_LABEL")}
              <span variant="body2" className={summaryClass.bodyText2}>
                {existingCustomer=="yes"?masterDataName:name}
              </span>
            </Typography>
            : <Skeleton />
          }
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
